import type { ConversationType, ItemRow } from 'owa-graph-schema';
import getStore from '../store/store';
import type { MailboxInfo } from 'owa-client-types';

export function filterItemRowsForHeadlines(rows: ItemRow[], mailboxInfo: MailboxInfo): ItemRow[] {
    const { selectedHeadlineItemIds } = getStore(mailboxInfo);

    return rows.filter(row => {
        return selectedHeadlineItemIds.includes(row.ItemId?.Id ?? '');
    });
}

export function filterConversationRowsForHeadlines(
    rows: ConversationType[],
    mailboxInfo: MailboxInfo
): ConversationType[] {
    const { selectedHeadlineConversationIds } = getStore(mailboxInfo);

    return rows.filter(row => {
        return selectedHeadlineConversationIds.includes(row.ConversationId?.Id ?? '');
    });
}
